export default __webpack_public_path__ + "static/media/our-extensive-banner.a1e93478.png";